import type { FileCategory, Song, SongCategory } from "./types";

export const SONG_CATEGORY_LABELS: Record<SongCategory, string> = {
  REQUIRED: "Imprescindible",
  FAVORITE: "Favorita",
  PREFERRED: "Preferida",
  IF_POSSIBLE: "Si es posible",
  FORBIDDEN: "Prohibida",
};

export const SONG_SOURCE_LABELS: Record<Song["source"], string> = {
  ADMIN: "Juan",
  CLIENT: "Pareja",
  GUEST: "Invitado",
};

export const FILE_CATEGORY_LABELS: Record<FileCategory, string> = {
  CONTRACT: "Contrato",
  QUOTE: "Presupuesto",
  MUSIC: "Música",
  IMAGE: "Imagen",
  DOCUMENT: "Documento",
  RIDER: "Rider",
  OTHER: "Otro",
};

export function normalizeSongValue(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("es")
    .replace(/[^a-z0-9]/g, "");
}
